import { render, staticRenderFns } from "./table-head-goal-setting.component.vue?vue&type=template&id=62507bf2&scoped=true"
import script from "./table-head-goal-setting.component.vue?vue&type=script&lang=ts"
export * from "./table-head-goal-setting.component.vue?vue&type=script&lang=ts"
import style0 from "./table-head-goal-setting.component.vue?vue&type=style&index=0&id=62507bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62507bf2",
  null
  
)

export default component.exports